import { CheckCircle2, XCircle, Clock } from 'lucide-react';

// Helpers de presentación de la revisión de evidencias. Los hooks de datos y
// los tipos de la API viven en @/api/instructor-evidence (ENG-LAYER-01).

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const STATUS_CONFIG = {
  pending: {
    label: 'Pendiente',
    icon: Clock,
    className: 'bg-yellow-500/10 text-yellow-600 ring-yellow-500/20',
  },
  approved: {
    label: 'Aprobada',
    icon: CheckCircle2,
    className: 'bg-green-500/10 text-green-600 ring-green-500/20',
  },
  rejected: {
    label: 'Rechazada',
    icon: XCircle,
    className: 'bg-red-500/10 text-red-600 ring-red-500/20',
  },
} as const;
